import type { NoteBlock } from "../../types";

/** Bloco de citação: texto grande centrado sobre cor chapada. */
export function NoteBlockCard({ block }: { block: NoteBlock }) {
	return (
		<a className="block-link" href={block.href}>
			<article className="block block--note" style={{ background: block.color }}>
				<blockquote className="block__note">
					<p>{block.text}</p>
					<footer>{block.source}</footer>
				</blockquote>
			</article>
		</a>
	);
}
